// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2wf1H","errorLogs":"EditorFooter_errorLogs__2Hebn"};